import { TimeSlot } from '../types/calendar'

// Simplified algorithm to find recommended slots
export function getHuecosDeOro(
  date: Date = new Date(),
  durationMinutes: number = 30,
): TimeSlot[] {
  const slots: TimeSlot[] = []
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()

  // Recommend slots for tomorrow or the day after
  const targetDate = new Date(year, month, day + 1)
  if (targetDate.getDay() === 0 || targetDate.getDay() === 6) {
    targetDate.setDate(
      targetDate.getDate() + (targetDate.getDay() === 0 ? 1 : 2),
    ) // Skip weekends
  }

  // Generate 3 recommended slots based on typical high-conversion times (e.g., 10:00, 12:30, 16:00)
  const recommendedTimes = [
    { h: 10, m: 0 },
    { h: 12, m: 30 },
    { h: 16, m: 0 },
  ]

  recommendedTimes.forEach((time) => {
    const start = new Date(
      targetDate.getFullYear(),
      targetDate.getMonth(),
      targetDate.getDate(),
      time.h,
      time.m,
    )
    const end = new Date(start.getTime() + durationMinutes * 60000)

    slots.push({
      start: start.toISOString(),
      end: end.toISOString(),
      isRecommended: true,
    })
  })

  return slots
}
